export default "__VITE_PUBLIC_ASSET__cc4c4495__"